import type { RouteObject } from "react-router-dom";
import { Spinner } from "@/components/ui/v2/spinner";
import { addSlashes, withCompanyPrefix } from "../route.utils";
import { CompanyAddOnsPage } from "@/utils/lazyLoadComponents";

// ─── Path Segments ────────────────────────────────────────────────────────────
// ROOT is the platform section's key ('add-ons'): the sidebar links to
// company/<key>.
export enum COMPANY_ADD_ONS_PATH_SEGMENTS {
  ROOT = "add-ons",
}

// ─── Route Definition ─────────────────────────────────────────────────────────
// Add-ons module: optional products a company subscribes to (Cameras first).
// Its own section ('Add ons'), so access is granted apart from Subscriptions.
export const companyAddOnsRoutes: RouteObject = {
  path: COMPANY_ADD_ONS_PATH_SEGMENTS.ROOT,
  handle: { breadcrumb: "Add-ons" },
  HydrateFallback: Spinner,
  Component: CompanyAddOnsPage,
};

// ─── Resolved Paths ───────────────────────────────────────────────────────────
export const COMPANY_ADD_ONS_PATHS = Object.freeze({
  ROOT: withCompanyPrefix(addSlashes(COMPANY_ADD_ONS_PATH_SEGMENTS.ROOT)),
});
